import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { EmptyState } from '../../shared/ui/components';
import { useMe } from '../session/SessionProvider';
import { DenominationCard } from '../denomination/denomination';
import { LiveSettingsCard } from '../live/LiveSettingsCard';
import { OnlinePaymentsCard } from '../finance/OnlinePaymentsCard';
import { AutomationSection } from '../automation/AutomationSection';

/**
 * Configuración de la iglesia: los ajustes generales que antes estaban regados en Sitio público,
 * Finanzas y Automatización. Cada sección aparece solo a quien puede usarla.
 */
export function ChurchSettingsPage() {
  const me = useMe();
  const churchId = me.activeChurchId;
  const { hash } = useLocation();
  // Desde los enlaces viejos (/app/automatizacion, Sitio público) se llega directo a la sección.
  useEffect(() => {
    if (hash) document.getElementById(hash.slice(1))?.scrollIntoView?.({ block: 'start' });
  }, [hash]);

  if (!churchId) return <EmptyState title="Elige primero la iglesia en la que actúas." />;
  const church = me.can('church.manage');
  const payments = church && me.can('finance.manage');
  const automation = me.can('automation.read');
  if (!church && !automation) return <EmptyState title="No tienes permiso para ver la configuración de la iglesia." />;

  return (
    <div className="page page--narrow">
      <header className="page__header">
        <h1>Configuración de la iglesia</h1>
        <p className="muted">Los ajustes generales de la iglesia, en un solo lugar.</p>
      </header>
      {church ? (
        <section id="denominacion" className="stack" aria-labelledby="cfg-denominacion">
          <h2 id="cfg-denominacion" className="section-title">Denominación</h2>
          <DenominationCard churchId={churchId} />
        </section>
      ) : null}
      {church ? (
        <section id="en-vivo" className="stack" aria-labelledby="cfg-en-vivo">
          <h2 id="cfg-en-vivo" className="section-title">En vivo</h2>
          <LiveSettingsCard churchId={churchId} />
        </section>
      ) : null}
      {payments ? (
        <section id="mercado-pago" className="stack" aria-labelledby="cfg-mercado-pago">
          <h2 id="cfg-mercado-pago" className="section-title">Mercado Pago</h2>
          <OnlinePaymentsCard churchId={churchId} />
        </section>
      ) : null}
      {automation ? (
        <section id="recordatorios" className="stack" aria-labelledby="cfg-recordatorios">
          <h2 id="cfg-recordatorios" className="section-title">Recordatorios automáticos</h2>
          <AutomationSection churchId={churchId} />
        </section>
      ) : null}
    </div>
  );
}
